import { client } from './client'
import type { NodeTypeDescriptor } from '@/types'

export const workflowNodeTypesApi = {
  getAll: (projectId: string) =>
    client.get<NodeTypeDescriptor[]>(`/projects/${projectId}/workflow-node-types`).then(r => r.data),
}
